import { c as _c } from "react/compiler-runtime";
import { Clipboard, Check } from "lucide-react";
import React, { useState } from "react";
interface CopyableContentProps {
  text: string;
  upperCase?: boolean;
  textClassName?: string;
  iconOnly?: boolean;
  alwaysShow?: boolean;
}
export function CopyableContent(t0) {
  const $ = _c(15);
  const {
    text,
    upperCase,
    textClassName,
    alwaysShow
  } = t0;
  const [justCopied, setJustCopied] = useState(false);
  let t1;
  if ($[0] !== text || $[1] !== upperCase) {
    t1 = upperCase ? text.toUpperCase() : text;
    $[0] = text;
    $[1] = upperCase;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedText = t1;
  let t2;
  if ($[3] !== formattedText) {
    t2 = async function handleCopy() {
      try {
        await navigator.clipboard.writeText(formattedText);
        setJustCopied(true);
        setTimeout(() => setJustCopied(false), 200);
      } catch {}
    };
    $[3] = formattedText;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCopy = t2;
  const t3 = `hover:opacity-70 transition-opacity duration-200 active:opacity-40 ${textClassName}`;
  let t4;
  if ($[5] !== formattedText || $[6] !== t3) {
    t4 = <span className={t3}>{formattedText}</span>;
    $[5] = formattedText;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== alwaysShow || $[9] !== justCopied) {
    t5 = justCopied ? <Check size={16} className="ml-1 text-green-600 transition-colors group-hover:opacity-100 inline" /> : <Clipboard size={16} className={`ml-1 text-muted-foreground ${alwaysShow ? "opacity-50" : "opacity-0"} group-hover:opacity-100 transition-opacity inline relative top-[-1px]`} />;
    $[8] = alwaysShow;
    $[9] = justCopied;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleCopy || $[12] !== t4 || $[13] !== t5) {
    t6 = <span className="relative group cursor-default text-foreground text-sm" onClick={handleCopy}>{t4}{t5}</span>;
    $[11] = handleCopy;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
export function CopyIcon(t0) {
  const $ = _c(7);
  const {
    text
  } = t0;
  const [justCopied, setJustCopied] = useState(false);
  const formattedText = text;
  let t1;
  if ($[0] !== formattedText) {
    t1 = async function handleCopy() {
      try {
        await navigator.clipboard.writeText(formattedText);
        setJustCopied(true);
        setTimeout(() => setJustCopied(false), 200);
      } catch {}
    };
    $[0] = formattedText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  if ($[2] !== justCopied) {
    t2 = justCopied ? <Check size={16} className="ml-1 text-green-600 transition-colors group-hover:opacity-100 inline" /> : <Clipboard size={16} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity inline relative top-[-1px]" />;
    $[2] = justCopied;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleCopy || $[5] !== t2) {
    t3 = <span className="relative group cursor-default" onClick={handleCopy}>{t2}</span>;
    $[4] = handleCopy;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}